import { useContext, useEffect, useState } from "react";
import {
  Icon,
  IconCalendarStats,
  IconDeviceDesktopAnalytics,
  IconFingerprint,
  IconGauge,
  IconHome2,
  IconLogout,
  IconSettings,
  IconSwitchHorizontal,
  IconUser,
} from "@tabler/icons-react";
import { Center, Stack, Text, Tooltip, UnstyledButton } from "@mantine/core";

import "./styles.scss";
import { RouteList } from "../../lib/Routes";
import { Link, useLocation } from "react-router-dom";
import { AppContext } from "../../pages/Dashboard";
interface NavbarLinkProps {
  icon: Icon;
  label: string;
  active?: boolean;
  onClick?: () => void;
}

function NavbarLink({ icon: Icon, label, active, onClick }: NavbarLinkProps) {
  return (
    <Tooltip label={label} position="right" transitionProps={{ duration: 0 }}>
      <UnstyledButton
        onClick={onClick}
        className="link"
        data-active={active || undefined}
      >
        <Icon size={20} stroke={1.5} />
      </UnstyledButton>
    </Tooltip>
  );
}

export default function Navbar() {
  const location = useLocation();
  const context = useContext(AppContext);
  const [active, setActive] = useState<string>("");

  useEffect(() => {
    const path = location.pathname.replaceAll("/dashboard/", "");
    const matchedRoute =
      path === ""
        ? [RouteList[0]]
        : RouteList.filter((r) => r.link !== "").filter((r) => path.includes(r.link));
    matchedRoute.length > 0 && setActive(matchedRoute[0].link);
  }, [location]);
  const links = RouteList.map((link, index) => (
    <Link to={`/dashboard/${link.link}`} key={link.link}>
      <NavbarLink
        label={link.label}
        icon={link.icon}
        key={link.label}
        active={link.link === active}
      />
    </Link>
  ));

  return (
    <div className="nav-container">
      <nav className="navbar">
        <Center>
          <Text fw={500} fz={17}>
            LOGO
          </Text>
        </Center>

        <div className="navbarMain">
          <Stack justify="center" gap={0}>
            {links}
          </Stack>
        </div>

        <Stack justify="center" gap={0}>
          <NavbarLink
            icon={IconLogout}
            label="Logout"
            onClick={() => {
              if (context) {
                context.logoutAdmin();
              }
            }}
          />
        </Stack>
      </nav>
    </div>
  );
}
